/**
 * Token Service
 * Sets up axios interceptors for automatic token handling
 */
import axios from 'axios';
import { getToken, logout } from './authService';

/**
 * Setup axios interceptors
 * This must be called once when the app starts
 */
export const setupInterceptors = () => {
  // Request interceptor - add auth token to all requests
  axios.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor - handle 401 errors (expired/invalid token)
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        // Token is invalid or expired
        console.warn('Authentication token expired or invalid');
        logout();

        // Redirect to login page if not already there
        if (window.location.pathname !== '/login' && window.location.pathname !== '/signup') {
          window.location.href = '/login?expired=true';
        }
      } else if (error.response?.status === 403) {
        // Trial expired or limit reached
        console.warn('Trial expired or limit reached');
        // Don't auto-logout, let the UI handle this
      }

      return Promise.reject(error);
    }
  );
};

export default {
  setupInterceptors
};
